@use 'kci-design-lib/styles/variables.scss' as *;
[data-pc-name='overlaypanel'] {
  &::before {
    display: none !important;
    content: '' !important;
  }
  [data-pc-section='closebutton'] {
    width: 30px !important;
    height: 30px !important;
    content: none !important;
    background: none;
    &:hover {
      border: 0px;
      img {
        filter: brightness(0) saturate(100%) invert(16%) sepia(72%) saturate(2478%)
          hue-rotate(209deg) brightness(91%) contrast(109%);
      }
    }
    margin: 5px 0 0;
    [alt='Close'] {
      width: 20px;
      height: 20px;
    }
    img {
      filter: brightness(0) saturate(100%) invert(39%) sepia(0%) saturate(0%) hue-rotate(0deg)
        brightness(100%) contrast(90%);
    }
  }
  [data-pc-section='content'] {
    div {
      &:has(> .filterheader) {
        padding-bottom: 0;
      }
    }
  }
  &:has(.filterheader) {
    &[data-pc-section='root'] {
      &::after {
        display: none;
      }
    }
    & ~ [data-pc-section='panel'] {
      &:has(.customCheckboxOption) {
        margin-top: 0;
      }
    }
  }
  [for='datePicker'] {
    span {
      &:last-child {
        display: none;
      }
    }
  }
  .statusFilter {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    padding-top: 24px;
    div {
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 12px;
    }
    span {
      &:last-child {
        line-height: 18px;
      }
    }
  }
  .allicon {
    padding-left: 4px;
  }
}
[id='anchor--primary--components-search--default'] {
  [scale='1'] {
    width: 100% !important;
  }
}
.fullWidthFilterPanel {
  font-family: $font-family;
  .inlineWrapper {
    display: block;
    margin-left: 0px;
    &:hover,
    &:has([aria-expanded='true']) {
      .inlineText {
        color: $pcl-main-text;
      }
      [data-pc-section='trigger'] {
        img {
          filter: brightness(62%) saturate(0%) invert(34%) sepia(0%) saturate(0%) hue-rotate(0deg)
            contrast(100%);
        }
        &:hover {
          img {
            filter: brightness(0) saturate(100%) invert(16%) sepia(79%) saturate(2478%)
              hue-rotate(209deg) brightness(90%) contrast(108%);
          }
        }
      }
    }
  }
  .w-full {
    padding-right: 0px !important;
  }
  background: $background-gradient;
  border: 1px solid $dropdown-border;
  border-radius: 4px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-top: none;
  padding: 8px 16px 24px;
  max-height: 400px;
  margin-left: -12.7px;
  margin-top: -4px;
  .inlineText {
    left: 18px;
    margin-top: 3px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: $pcl-main-text;
  }
  [data-pc-name='multiselect'] {
    border: 1px solid $dropdown-border;
    background: $lighterblue;
    margin: 4px 0 0;
    box-shadow: none !important;
    padding: 12px 16px;
  }
  .filterItem {
    label {
      font-family: 'Open Sans', sans-serif !important;
      font-weight: 700;
      font-size: 16px;
      color: $pcl-main-text;
      line-height: 160%;
    }
  }
  & ~ [data-pc-section='panel'] {
    margin: 0;
  }
  [data-pc-section='label'] {
    padding: 0 8px 0 0;
  }
}
[data-position='bottom-right'] {
  [data-button-type='tertiary'] {
    &:hover {
      border-bottom: 1px solid var(--tertiary-btn-brdr-hover-btm) !important;
    }
  }
}
.searchContainer {
  position: relative;
  width: 100%;
  text-align: right;
  display: flex;
  justify-content: flex-end;
  .closeIcon {
    [data-pc-name='button'] {
      padding: 0px;
      img {
        filter: brightness(62%) saturate(0%) invert(34%) sepia(0%) saturate(0%) hue-rotate(0deg)
          contrast(100%);
      }
      &:hover {
        border-color: transparent !important;
        img {
          filter: brightness(0) saturate(100%) invert(16%) sepia(79%) saturate(2478%)
            hue-rotate(209deg) brightness(90%) contrast(108%);
        }
      }
    }
  }
  .filterbtn {
    [data-pc-name='button'] {
      padding: 0px 0px 0 0;
      height: 31px;
      img {
        filter: brightness(62%) saturate(0%) invert(34%) sepia(0%) saturate(0%) hue-rotate(0deg)
          contrast(100%);
        width: 20px;
        height: 20px;
      }
      &:hover {
        border: 0px;
        img {
          filter: brightness(0) saturate(100%) invert(14%) sepia(96%) saturate(3475%)
            hue-rotate(211deg) brightness(92%) contrast(104%);
        }
      }
    }
    button {
      height: unset;
      margin: 0px;
      img {
        width: 20px !important;
        height: 20px !important;
      }
    }
    [data-button-type='tertiary'] {
      padding: 0 !important;
      height: 30px !important;
      width: 30px !important;
      border-radius: 50% !important;
      display: flex !important;
      align-items: center;
      margin: 0;
      &:hover {
        border: 0px !important;
        box-shadow: none !important;
        img {
          filter: brightness(0) saturate(100%) invert(16%) sepia(79%) saturate(2478%)
            hue-rotate(209deg) brightness(90%) contrast(108%);
        }
      }
    }
    &.inputActivePopover {
      background: $pcl-main-bkgd;
      [role='button'] {
        [data-button-type='tertiary'] {
          background: $lighterblue;
        }
      }
    }
  }
  .filterbtn[class~='active'] {
    img {
      filter: brightness(0) saturate(100%) invert(16%) sepia(79%) saturate(2478%) hue-rotate(209deg)
        brightness(90%) contrast(108%);
    }
  }
  &.autoContainer {
    font-family: $font-family;
    .searchRightBox {
      > div {
        gap: 8px;
        margin: 0px !important;
        > div.closeIcon {
          [data-button-type='tertiary'] {
            background: none;
            width: auto;
            padding: 0px;
            img {
              margin: 0px 0 0;
            }
          }
        }
      }
      [data-pc-name='multiselect'] {
        background: none;
        border: 0px;
        padding: 0px;
        gap: 8px;
        &:not(.p-disabled):focus,
        &:not(.p-disabled).p-focus-visible,
        &:not(.p-disabled):focus-within {
          box-shadow: none !important;
          outline: none;
        }
        [data-pc-section='label'] {
          font-size: 14px;
          font-weight: 600;
          padding: 0px;
          font-family: 'Open Sans', sans-serif !important;
          max-width: 130px;
        }
        [data-pc-section='trigger'] {
          padding: 0px;
          width: 16px;
          margin: 0;
          img {
            width: 22px;
          }
          svg {
            width: 8px;
            height: 13px;
            margin-top: 3px;
          }
        }
      }
    }
  }
  .searchRightBox {
    background: none;
    gap: 8px;
  }
  .searchLeftBox {
    input {
      background: none;
    }
    .chipInside {
      border: 1px solid $dropdown-border;
      background: $pcl-main-bkgd;
      border-radius: 16px;
      height: 32px;
      padding: 6px 8px 6px 12px;
      color: $pcl-main-text;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0.75px;
      &.chipPluse {
        padding: 6px;
      }
      button {
        background: none;
      }
      [data-button-type='tertiary'] {
        border: 0 !important;
        border-bottom: 0 !important;
        background: transparent !important;
        box-shadow: none !important;
        &:hover,
        &:focus,
        &:active {
          border: 0 !important;
          border-bottom: 0 !important;
          background: transparent !important;
          box-shadow: none !important;
        }
      }
      img {
        height: 20px;
        width: 20px;
      }
    }
    img {
      filter: brightness(0) saturate(100%) invert(39%) sepia(0%) saturate(0%) hue-rotate(0deg)
        brightness(100%) contrast(90%);
    }
  }
  .searchButtonWrapper {
    button {
      &:hover {
        border-color: transparent !important;
      }
      img {
        filter: brightness(62%) saturate(0%) invert(34%) sepia(0%) saturate(0%) hue-rotate(0deg)
          contrast(100%);
      }
    }
  }
  [class~='filterbtn'][class~='active-trigger'][data-button-type='tertiary'] {
    background: $lighterblue !important;
  }
  .inputActivePopover {
    .filterbtn {
      button {
        background: $border-dark;
      }
    }
  }
  &.noFilter:has(input:focus) {
    .searchLeftBox img {
      filter: brightness(0) saturate(100%) invert(14%) sepia(28%) saturate(1198%) hue-rotate(181deg)
        brightness(73%) contrast(104%);
    }
  }
  &.fullwidthContainer {
    font-family: $font-family;
    .filterbtn {
      [data-button-type='tertiary'] {
        height: 36px !important;
        width: 36px !important;
      }
    }
  }
  [data-button-type='tertiary'] {
    &:hover {
      border-bottom-color: transparent;
    }
  }
}
[id='search-filter-popover'][data-pc-section='root'] {
  background: transparent;
  width: 466px !important;
  max-width: 100%;
  border-radius: 0px;
  box-shadow: none;
  margin-top: 1px;
  margin-left: 7px;
  [class~='allstatus'] {
    padding: 0px;
    .status {
      padding: 0px;
    }
  }
  .btngroupspacer {
    padding: 0px;
    display: flex;
    margin-left: auto;
    button:last-child {
      margin-right: 0px;
    }
    [data-button-type='tertiary'] {
      border-bottom: 1px solid transparent;
    }
  }
  .custom-datepicker:has([data-pc-name='calendar']) {
    width: 100%;
  }
  [data-pc-section='content'] {
    padding: 0 !important;
    overflow: visible !important;
    height: auto !important;
    max-height: 100%;
    position: relative;
    box-shadow: 0px 4px 12px 0px $shadow-brand-soft-precise;
    width: 466px;
    background: $pcl-main-bkgd;
    right: 0;
    div {
      &:has(.filtercont),
      &:has(.filterheader) {
        padding-right: 0px;
        box-shadow: none;
      }
    }
    [data-pc-section='list'] {
      span {
        font-size: 14px;
        color: $pcl-main-text;
        font-weight: 400;
      }
    }
    [data-pc-name='calendar'] {
      ::placeholder {
        font-size: 14px;
        color: $pbl-text-dsbl;
        font-weight: 400;
      }
    }
    .filtercont {
      padding: 24px 12px 24px 24px;
      overflow-y: scroll;
      height: 50vh;
      scrollbar-width: thin;
      scrollbar-color: $dropdown-border transparent;
      .inlineText {
        left: 18px;
        top: 23px;
        color: $pcl-main-text;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
      }
      &::-webkit-scrollbar {
        width: 4px;
        height: 6px;
      }
      &::-webkit-scrollbar-button {
        display: none;
        width: 0;
        height: 0;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      &::-webkit-scrollbar-thumb {
        background-color: $dropdown-border;
        border-radius: 8px;
      }
      &::-webkit-scrollbar-thumb:hover {
        background-color: $pdarkgrey;
      }
      label {
        font-size: 16px;
        font-weight: 700;
        color: $pcl-main-text;
        line-height: 160%;
      }
      [data-pc-name='multiselect'] {
        background: $lighterblue !important;
        border-radius: 4px !important;
        border: 1px solid $dropdown-border !important;
        height: 48px;
        margin-bottom: 24px;
        align-items: center;
        padding: 12px 16px;
        &.p-multiselect:not(.p-disabled).p-focus {
          box-shadow: none !important;
        }
        [data-pc-section='labelcontainer'] {
          visibility: hidden;
          div {
            font-size: 16px;
            color: $pcl-main-text;
            font-weight: 400;
            padding: 0px;
            margin: 0px;
            background: none;
          }
        }
      }
      [data-pc-name='calendar'] {
        width: 100%;
        input {
          background: $lighterblue;
          border-radius: 4px;
          border: 1px solid $dropdown-border;
        }
      }
      [data-pc-section='trigger'] {
        width: 24px;
        height: 24px;
      }
    }
    .statusFilter {
      flex-direction: column;
      img {
        filter: none;
      }
      label {
        display: none;
      }
      div {
        padding-left: 0px;
      }
      span {
        color: $pcl-main-text;
      }
    }
    .filterheader {
      background: $border-dark;
      max-width: 466px;
      width: 100%;
      border-bottom: 1px solid $dropdown-border;
      padding: 17px 24px;
      font-size: 20px;
      font-weight: 700;
      letter-spacing: 0.2px;
      margin-bottom: 0px;
      color: $pbd-text-hover;
    }
  }
  [data-pc-name='button'] {
    width: auto;
    height: auto;
    margin-right: 23.5px;
    &:last-child {
      border-radius: 4px;
    }
    &:first-child {
      label {
        font-weight: 600;
      }
    }
  }
  .filterfooter {
    padding: 16px 24.5px 16px 29px;
    border-top: 1px solid $dropdown-border;
    & > div {
      display: inline-flex;
    }
    [role='button'] {
      margin-top: 0px;
      div {
        background: none;
        margin: 0;
        padding: 0;
      }
    }
    .icon-container {
      &:has(.icon.filled) {
        background: none;
      }
    }
    > div {
      [data-button-type='primary'] {
        &:last-child {
          label {
            font-weight: 600 !important;
            letter-spacing: 0.2px !important;
          }
        }
      }
    }
    [data-button-type='primary'] {
      padding: 8px 24px;
    }
  }
}
.searchFilterPopover {
  background: transparent !important;
  border-radius: 0;
  box-shadow: none !important;
  margin: -3px 0 0 21px;
  max-width: 466px !important;
  overflow: visible !important;
  width: 466px !important;
  &.overlay-panel:not(.hide-pointer)[data-pc-name='overlaypanel'] {
    [alt='Close'] {
      width: 20px;
      height: 20px;
    }
  }
  &::before,
  &::after {
    display: none !important;
  }
  [data-pc-section='content'] {
    background: var(--search-surface, #{$pcl-main-bkgd});
    box-shadow: 0px 4px 12px 0px $shadow-brand-soft-precise;
    max-height: none !important;
    overflow: visible !important;
    padding: 0 !important;
    width: 466px;
  }
  [class*='popover-header'],
  [class*='popover-content'] {
    padding: 0 !important;
  }
  .filterheader {
    align-items: center;
    background: var(--search-header-bg, #{$border-dark});
    border-bottom: 1px solid var(--border-elevated, #{$dropdown-border});
    color: var(--search-header-text, #{$pbd-text-hover});
    display: flex;
    font-size: 20px;
    font-weight: 700;
    justify-content: space-between;
    letter-spacing: -0.2px;
    line-height: 32px;
    margin: 0;
    max-width: 466px;
    padding: 14px 21px 14px 24px;
    width: 100%;
  }
  .filtercont {
    height: 50vh;
    overflow-y: auto;
    padding: 24px 12px 24px 24px;
    scrollbar-color: $dropdown-border transparent;
    scrollbar-width: thin;
    &::-webkit-scrollbar {
      width: 3px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background-color: $dropdown-border;
      border-radius: 6px;
    }
  }
  label[for='datePicker'] {
    color: var(--search-selected-value-text, var(--checkbox-radio-text)) !important;
    font-size: 16px;
    font-weight: 700;
    line-height: 160%;
    margin-bottom: 8px;
    span:first-child {
      color: var(--search-selected-value-text, var(--checkbox-radio-text)) !important;
    }
  }
  [data-pc-name='calendar'] {
    height: 48px;
    max-width: 100%;
    position: relative;
    width: 100%;
    [data-pc-name='inputtext'] {
      width: 100%;
    }
    button {
      align-items: center;
      background: transparent !important;
      border: none !important;
      box-shadow: none !important;
      display: inline-flex;
      height: 48px !important;
      justify-content: center;
      min-width: 48px !important;
      padding: 0 !important;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 48px !important;
      img,
      svg {
        height: 22px;
        width: 22px;
      }
    }
  }
  .filterfooter {
    align-items: center;
    border-top: 1px solid var(--border-elevated, #{$dropdown-border});
    display: flex;
    gap: 8px;
    justify-content: flex-end;
    margin: 0;
    padding: 16px 24.5px 16px 29px;
    > div:first-child {
      display: inline-flex;
      flex: 0 0 auto;
    }
    [role='button'] {
      margin-top: 0;
    }
    button,
    [data-pc-name='button'] {
      min-width: max-content !important;
      width: auto !important;
      height: 40px !important;
      max-height: none !important;
      padding: 8px 12px !important;
      label,
      .button-label {
        display: inline-block !important;
        white-space: nowrap;
      }
    }
    [data-button-type='tertiary']:not(:has(label)) {
      height: 24px !important;
      min-width: 24px !important;
      padding: 0 !important;
      width: 24px !important;
    }
  }
  .btngroupspacer {
    align-items: center;
    display: flex;
    gap: 8px;
    justify-content: flex-end;
    padding: 0;
    button:last-child {
      margin-right: 0;
    }
    [data-button-type='tertiary'] {
      border-bottom: 1px solid transparent;
    }
    [data-button-type='primary'] {
      height: 40px !important;
      min-width: max-content !important;
      padding: 8px 12px;
      width: auto !important;
    }
    [data-button-type='tertiary']:has(label) {
      height: 40px !important;
      min-width: max-content !important;
      padding: 8px 12px !important;
      width: auto !important;
    }
  }
}
[class~='css-1mz8bi6'] {
  width: 100% !important;
}
.css-ktn9bh {
  width: 100% !important;
}
[class~='_circle_1qgzb_41'] {
  filter: brightness(0) saturate(100%) invert(22%) sepia(96%) saturate(4200%) hue-rotate(222deg)
    brightness(95%) contrast(104%) !important;
}
.inputWrapper {
  position: relative;
  width: 100%;
  min-height: 40px;
  border: 1px solid $input-bg;
  border-radius: 8px;
  background: $pcl-main-bkgd;
  padding-left: 42px; 
  padding-right: 42px; 
  display: flex;
  align-items: center;
  box-sizing: border-box;
}
.inputField {
  flex: 1;
  border: none;
  outline: none;
  min-width: 120px;
  height: 32px;
  font-size: 16px;
  line-height: 24px;
  background: transparent;
  color: $pcl-main-text;
}
.inputWrapper button {
  position: absolute;
  right: 10px !important;
  top: 50%;
  transform: translateY(-50%);
}
.iconRight {
  position: absolute;
  right: 12px; 
  top: 50%;
  transform: translateY(-50%);
  transition: all 0.25s ease;
}
.iconShiftLeft {
  position: absolute;
  left: 12px;
  right: auto; 
  top: 50%;
  transform: translateY(-50%);
  transition: all 0.25s ease;
}
.filterDisplay {
  display: block; 
}
.filterNone {
  display: none; 
}
.filterButtonInside {
  flex-shrink: 0; 
  cursor: pointer;
}
.filterOverlay {
  padding: 0 !important;
  border-radius: 12px;
  box-shadow: 0px 4px 16px $overlay-black-15;
}
.filterPanel {
  padding: 16px;
  min-width: 280px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.suggestionList {
  background: $background-gradient !important;
  border: 1px solid $dropdown-border;
  border-radius: 4px;
  max-height: 200px;
  overflow-y: auto;
  padding: 2px 0 6px;
  list-style: none;
  z-index: 99999 !important;
  display: block !important;
  visibility: visible !important;
  margin-top: -4px;
  border-top: none;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  li {
    display: block;
  }
  button {
    &:hover {
      border: 0px;
    }
  }
  &.selectionList {
    &.fullWidthList {
      margin-top: 4px;
    }
  }
}
.suggestionItem {
  display: block;
  width: 100%;
  text-align: left;
  padding: 6px 16px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  font-family: $font-family;
  &:hover {
    color: $sbl-text-hover;
  }
}
.searchBox {
  position: relative;
  width: 100%;
  min-height: 40px;
  border: 1px solid $input-bg;
  border-radius: 8px;
  background: $pcl-main-bkgd;
  padding-left: 42px;
  padding-right: 42px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}
.filterRow {
  width: 100%;
  min-height: 40px;
  border: 1px solid $input-bg;
  border-radius: 8px;
  background: $pcl-main-bkgd;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.searchRow {
  display: flex;
  gap: 12px;
  width: 100%;
  min-height: 40px;
  border-bottom: 1px solid $dropdown-border;
  border-radius: 0px;
  background: $lighterblue;
  padding: 0 9px 0 12px;
  align-items: center;
  box-sizing: border-box;
  &.inputActivePopover {
    background-color: $pcl-main-bkgd !important;
    .filterbtn {
      img {
        filter: brightness(0) saturate(100%) invert(16%) sepia(79%) saturate(2478%)
          hue-rotate(209deg) brightness(90%) contrast(108%) !important;
      }
    }
  }
}
.searchLeftBox {
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 32%;

  .chipInputBox {
    position: relative;
    display: flex;
    align-items: center;
    gap: 6px;
    flex: 1;
    margin-left: 8px;
    width: 90%;
    min-width: 0;

    .searchPlaceholder {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      pointer-events: none;
      white-space: nowrap;
      z-index: 0;
    }

    &:focus-within .searchPlaceholder {
      display: none;
    }

    .inputField {
      position: relative;
      z-index: 1;
      flex: 1 1 auto;
      min-width: 1px;
      width: 100%;
      border: none;
      outline: none;
      background: transparent;
      padding: 0;
      margin: 0;
    }

    .inputField::placeholder {
      color: transparent;
      opacity: 0;
    }

    .chipInside {
      position: relative;
      z-index: 2;
      display: flex;
      justify-content: center;
      white-space: nowrap;

      button {
        height: 20px;
        width: 20px;
        margin-left: 4px;
      }
    }
  }

  .icon-container {
    &:has(.icon.filled) {
      padding-right: 12px;
    }
  }
}
.searchRightBox > * {
  flex-shrink: 0; 
}
.searchRightBox {
  max-width: 100%;
  display: flex;
  flex-wrap: wrap; 
  gap: 6px;
  align-items: center;
  justify-content: end;
  padding: 6px 0 6px 10px;
  overflow: visible; 
  .smallBadge {
    background: none;
    font-size: 14px;
    color: $default-neutral;
    font-weight: 600;
  }
  .moreCount {
    background: $pbl-bkgd-hover;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.75;
    color: $pcl-main-bkgd;
  }
}
.selectedStatusTags {
  display: flex;
  gap: 6px;
  align-items: center;
  flex-wrap: wrap;
}
.selectedStatusDisplay {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: nowrap; 
  overflow: hidden; 
}
.moreCount {
  padding: 2px 6px !important;
  border-radius: 12px;
  background: $count-color;
  color: $pbl-bkgd-hover;
  font-size: 12px;
  font-weight: 500;
}
.searchButtonWrapper {
  display: center;
  justify-content: flex-end;
  width: 100%;
}
.agentTypesMultiSelect,
.foldersMultiSelect,
.dateRangePicker {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  label {
    font-size: 12px; 
    font-weight: 500;
    margin-bottom: 4px;
  }
}
.p-multiselect {
  .p-multiselect-token {
    font-size: 12px;
    padding: 2px 6px;
  }
  .p-multiselect-label {
    font-size: 12px;
  }
}
.smallBadge {
  padding: 2px 8px;
  border-radius: 12px;
  background: $badge-bg;
  color: $pbl-bkgd-hover;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}
.dateRangePicker {
  .p-inputtext {
    font-size: 12px;
    padding: 6px 8px;
    height: 32px;
  }
}
.searchRightBoxFullWidth {
  position: relative;
  width: 100%;
}
.filterButtonWrapper {
  margin-bottom: 0.5rem;
}
[data-pc-section='panel'] {
  width: 176px;
  box-shadow: none;
  border-radius: 8px;
  margin-top: 18px;
  [data-pc-name='checkbox'] {
    margin: 0px;
    background-color: transparent;
  }
  [data-pc-section='header'] {
    display: none;
  }
  [data-pc-section='item'] {
    span {
      font-size: 14px;
      font-weight: 400;
      letter-spacing: 0.2px;
      width: 100%;
      color: $default-neutral;
    }
    [data-pc-section='checkboxcontainer'] {
      display: none;
    }
    &:has(.customCheckboxOption) {
      padding: 10px 12px 10px 16px;
      font-family: $font-family;
    }
  }
  [role='option'] {
    background-color: transparent !important;
  }
  [data-p-highlight='true'] {
    background-color: transparent !important;
    [icon] {
      width: 16px;
      height: 16px;
      background: $sbl-text !important;
      border-radius: 4px;
    }
  }
}
.filterItem {
  margin-bottom: 8px;
  &:last-child {
    margin: 0;
  }
}
[data-pc-section='panel']:has(.filterItem),
[data-pc-section='panel']:has(.customCheckboxOption),
[class~='p-multiselect-overlay']:has(.filterItem),
[class~='p-multiselect-overlay']:has(.customCheckboxOption),
[class~='p-multiselect-panel']:has(.filterItem),
[class~='p-multiselect-panel']:has(.customCheckboxOption) {
  background: var(--search-surface, var(--main-bkgd)) !important;
  border: 1px solid #c9d3f8 !important;
  border-radius: 8px !important;
  box-shadow: 0px 4px 12px 0px rgba(12, 35, 60, 0.1490196078) !important;
  margin-top: 10px !important;
  overflow: hidden !important;
  padding: 4px 12px 4px 16px !important;
}
[data-pc-section='panel']:has(.filterItem) [data-pc-section='list'],
[data-pc-section='panel']:has(.customCheckboxOption) [data-pc-section='list'],
[class~='p-multiselect-overlay']:has(.filterItem) [class~='p-multiselect-list'],
[class~='p-multiselect-overlay']:has(.customCheckboxOption) [class~='p-multiselect-list'],
[class~='p-multiselect-panel']:has(.filterItem) [class~='p-multiselect-list'],
[class~='p-multiselect-panel']:has(.customCheckboxOption) [class~='p-multiselect-list'] {
  padding: 0 !important;
}
[data-pc-section='panel']:has(.filterItem) [data-pc-section='option'],
[data-pc-section='panel']:has(.customCheckboxOption) [data-pc-section='option'],
[data-pc-section='panel']:has(.customCheckboxOption) [data-pc-section='item'],
[class~='p-multiselect-overlay']:has(.filterItem) [class~='p-multiselect-option'],
[class~='p-multiselect-overlay']:has(.customCheckboxOption) [class~='p-multiselect-option'],
[class~='p-multiselect-panel']:has(.filterItem) [class~='p-multiselect-option'],
[class~='p-multiselect-panel']:has(.customCheckboxOption) [class~='p-multiselect-option'] {
  padding: 10px 0 !important;
}
[data-pc-section='panel']:has(.customCheckboxOption) .customCheckboxOption,
[class~='p-multiselect-overlay']:has(.customCheckboxOption) .customCheckboxOption,
[class~='p-multiselect-panel']:has(.customCheckboxOption) .customCheckboxOption {
  box-sizing: border-box;
  width: 100%;
  padding-left: 0 !important;
  padding-right: 0 !important;
}
[data-pc-section='panel']:has(.filterItem) [data-pc-section='option']:hover,
[data-pc-section='panel']:has(.filterItem) [data-pc-section='option'].p-focus,
[data-pc-section='panel']:has(.filterItem) [data-pc-section='option'].p-highlight,
[data-pc-section='panel']:has(.filterItem) [data-pc-section='option'][data-p-focused='true'],
[data-pc-section='panel']:has(.customCheckboxOption) [data-pc-section='option']:hover,
[data-pc-section='panel']:has(.customCheckboxOption) [data-pc-section='option'].p-focus,
[data-pc-section='panel']:has(.customCheckboxOption) [data-pc-section='option'].p-highlight,
[data-pc-section='panel']:has(.customCheckboxOption) [data-pc-section='option'][data-p-focused='true'],
[data-pc-section='panel']:has(.filterItem) [data-pc-section='item']:hover,
[data-pc-section='panel']:has(.filterItem) [data-pc-section='item'].p-focus,
[data-pc-section='panel']:has(.filterItem) [data-pc-section='item'].p-highlight,
[data-pc-section='panel']:has(.filterItem) [data-pc-section='item'][data-p-focused='true'],
[data-pc-section='panel']:has(.customCheckboxOption) [data-pc-section='item']:hover,
[data-pc-section='panel']:has(.customCheckboxOption) [data-pc-section='item'].p-focus,
[data-pc-section='panel']:has(.customCheckboxOption) [data-pc-section='item'].p-highlight,
[data-pc-section='panel']:has(.customCheckboxOption) [data-pc-section='item'][data-p-focused='true'],
[class~='p-multiselect-overlay']:has(.filterItem) [class~='p-multiselect-option']:hover,
[class~='p-multiselect-overlay']:has(.filterItem) [class~='p-multiselect-option'][class~='p-focus'],
[class~='p-multiselect-overlay']:has(.filterItem) [class~='p-multiselect-option'][class~='p-highlight'],
[class~='p-multiselect-overlay']:has(.filterItem) [class~='p-multiselect-option'][data-p-focused='true'],
[class~='p-multiselect-overlay']:has(.customCheckboxOption) [class~='p-multiselect-option']:hover,
[class~='p-multiselect-overlay']:has(.customCheckboxOption) [class~='p-multiselect-option'][class~='p-focus'],
[class~='p-multiselect-overlay']:has(.customCheckboxOption) [class~='p-multiselect-option'][class~='p-highlight'],
[class~='p-multiselect-overlay']:has(.customCheckboxOption) [class~='p-multiselect-option'][data-p-focused='true'],
[class~='p-multiselect-panel']:has(.filterItem) [class~='p-multiselect-option']:hover,
[class~='p-multiselect-panel']:has(.filterItem) [class~='p-multiselect-option'][class~='p-focus'],
[class~='p-multiselect-panel']:has(.filterItem) [class~='p-multiselect-option'][class~='p-highlight'],
[class~='p-multiselect-panel']:has(.filterItem) [class~='p-multiselect-option'][data-p-focused='true'],
[class~='p-multiselect-panel']:has(.customCheckboxOption) [class~='p-multiselect-option']:hover,
[class~='p-multiselect-panel']:has(.customCheckboxOption) [class~='p-multiselect-option'][class~='p-focus'],
[class~='p-multiselect-panel']:has(.customCheckboxOption) [class~='p-multiselect-option'][class~='p-highlight'],
[class~='p-multiselect-panel']:has(.customCheckboxOption) [class~='p-multiselect-option'][data-p-focused='true'] {
  background: transparent !important;
}
.suggestionItem:hover,
[data-pc-section='item']:hover,
[data-pc-section='option']:hover {
  background: transparent !important;
}
.filterLabel {
  display: block;
  margin-bottom: 4px;
  font-weight: 500;
}
.filterActions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.inputActivePopover {
  background: $pcl-main-bkgd;
}
.closeIcon {
  right: 10px;
}
.inlineFilter {
  right: inherit;
}
.datemain {
  top: auto;
  margin-bottom: 24px;
}
.autoContainer {
  width: 100%;
  .p-inputwrapper-filled {
    & + .inlineText {
      left: 17px;
    }
  }
  .searchButtonWrapper {
    [data-button-type='tertiary']:hover {
      background: transparent;
      img {
        filter: brightness(0) saturate(100%) invert(16%) sepia(72%) saturate(2478%)
          hue-rotate(209deg) brightness(91%) contrast(109%);
      }
    }
    [data-button-type='tertiary'] {
      border-radius: 50%;
      max-height: 40px;
      width: 40px;
      padding: 0;
    }
  }
  .searchRow {
    height: 40px;
    border: 1px solid $dropdown-border;
    border-radius: 4px;
    background: $lighterblue;
    width: 100%;
    [data-button-type='tertiary'] {
      padding: 0;
      height: 30px;
      width: 30px;
      background: $lighterblue;
      border-radius: 50%;
      display: flex;
      align-items: center;
      margin: 0;
      border: 0px;
    }
    &.inputActivePopover {
      background: $pcl-main-bkgd;
      [role='button'] {
        [data-button-type='tertiary'] {
          img {
            filter: brightness(0) saturate(100%) invert(16%) sepia(79%) saturate(2478%)
              hue-rotate(209deg) brightness(90%) contrast(108%);
          }
        }
      }
    }
    &.selectionBehavior {
      &:has(input[value]:not([value=''])) {
        background-color: $pcl-main-bkgd;
      }
    }
  }
  .searchRightBox {
    height: 40px;
    padding: 0px;
  }
  .inlineText {
    display: inline-flex;
    align-items: center;
    margin: 0;
    padding: 0;
    white-space: nowrap;
    font-size: 14px;
    font-weight: 600;
    color: $default-neutral;
    font-family: 'Open Sans', sans-serif !important;
  }
  .inlineWrapper {
    display: flex;
    align-items: center; 
    gap: 4px; 
  }
}
.fullwidthContainer {
  .searchLeftBox {
    .chipInside {
      button {
        height: auto !important;
        margin-top: 0px !important;
      }
    }
  }
  .inlineWrapper {
    [data-pc-section='label'] {
      visibility: hidden;
      text-align: left;
    }
  }
  .selectedStatusDisplay {
    > div {
      &.status {
        padding: 0px;
      }
      .moreCount {
        padding: 2px 6px !important;
      }
    }
  }
  [data-pc-section='labelcontainer'] {
    > div {
      display: inline-flex;
      align-items: center;
      margin: 0;
      padding: 0;
      white-space: nowrap;
      font-size: 14px;
      font-weight: 600;
      color: $default-neutral;
      font-family: 'Open Sans', sans-serif !important;
      line-height: 20px;
    }
  }
  .searchRightBox {
    > div {
      gap: 8px !important;
      margin: 0px !important;
      > div.closeIcon {
        [data-button-type='tertiary'] {
          background: none;
          width: auto;
          padding: 0px;
          img {
            margin: 0px 0 0;
          }
        }
      }
    }
    [data-pc-name='multiselect'] {
      background: none;
      border: 0px;
      padding: 0px;
      gap: 8px;
      box-shadow: none !important;
      [data-pc-section='label'] {
        font-size: 14px;
        font-weight: 600;
        padding-left: 0px;
        padding-right: 0px;
        font-family: 'Open Sans', sans-serif !important;
      }
      [data-pc-section='trigger'] {
        padding: 0px;
        width: 16px;
        margin: 4px 0 0 5px;
        img {
          width: 16px;
          height: 16px;
        }
        svg {
          width: 8px;
          height: 13px;
          margin-top: 3px;
        }
      }
    }
  }
  [data-pc-section='item'] {
    padding-left: 5px !important;
  }
  width: 100%;
  .searchRow {
    height: 48px;
    padding: 0 13px 0 20px;
    &.selectionBehavior {
      &:has(input[value]:not([value=''])) {
        background-color: $pcl-main-bkgd;
      }
    }
  }
}
.filtercloseButtonInside {
  display: flex;
  align-items: center;
  margin-bottom: 0;
}
.fullwidthContainer {
  .filterButtonInside,
  .filtercloseButtonInside {
    align-items: center;
    display: inline-flex;
    margin-bottom: 0;
    .filterbtn,
    .filterbtn [data-button-type='tertiary'] {
      align-items: center;
      display: inline-flex;
      height: 44px;
      justify-content: center;
      width: 44px;
    }
    .filterbtn img,
    .filterbtn .icon,
    .filterbtn svg {
      display: block;
      flex-shrink: 0;
      height: 20px;
      margin: 0;
      width: 20px;
    }
  }
}
.inlineWrapper {
  position: relative;
  margin-left: 4px;
  &:first-child {
    margin: 0;
  }
  [data-pc-section='trigger'] {
    img {
      filter: brightness(62%) saturate(0%) invert(34%) sepia(0%) saturate(0%) hue-rotate(0deg)
        contrast(100%);
    }
  }
  &:hover,
  &:has([aria-expanded='true']) {
    .inlineText {
      color: $pbl-bkgd-hover;
    }
    img {
      filter: brightness(0) saturate(100%) invert(16%) sepia(79%) saturate(2478%) hue-rotate(209deg)
        brightness(90%) contrast(108%);
    }
  }
  [data-pc-section='label'] {
    visibility: hidden;
  }
}
.inlineText {
  position: absolute;
  right: 25px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 600;
  color: $default-neutral;
}
body {
  [data-pc-section='item'] {
    &:hover {
      background: $lighterblue;
    }
    span {
      font-size: 12px;
      font-weight: 600;
      letter-spacing: 0.2px;
      color: $pcl-main-text;
    }
  }
}
.activeFilter {
  background: $badge-bg !important;
  border: 1px solid $pbl-bkgd-hover !important;
  color: $pbl-bkgd-hover !important;
}
.popover-content {
  [data-pc-name='multiselect'] {
    margin: 0px !important;
  }
}
[data-pc-section='tablebodyrowprops'] {
  td {
    [aria-selected='true'] {
      color: $sbl-text;
    }
  }
}
p-checkbox[class~='p-component'] {
  display: none !important;
}
.customCheckboxOption {
  align-items: center;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
}
.conatainerClick {
  transform: scale(0.99);
  border-color: $link-blue-700;
}
.chipInputtext {
  max-width: 59px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.chipPluse {
  background: $sbl-bkgd;
}
[id='anchor--components-search--default'] {
  [scale='1'] {
    width: 100% !important;
  }
}
button:focus {
  outline: none !important;
  box-shadow: none !important;
}
[data-pc-section='list'] {
  &:has(.customCheckboxOption) {
    padding: 4px 0;
  }
}
html[data-theme='dark'],
html[class~='p-dark'],
body[class~='dark-mode'],
[class~='dark-mode'],
[class~='p-dark'] {
  --search-icon-filter: brightness(0) saturate(100%) invert(100%) sepia(47%) saturate(3318%) hue-rotate(175deg) brightness(109%) contrast(101%);
  --search-icon-hover-filter: brightness(0) saturate(100%) invert(80%) sepia(40%) saturate(431%) hue-rotate(170deg) brightness(103%) contrast(101%);
  --search-icon-color: var(--text-emphasis);
  --search-icon-hover-color: var(--tertiary-btn-text-hover);
  --search-surface: var(--surface-elevated);
  --search-header-bg: var(--surface-elevated);
  --search-header-text: var(--text-emphasis);
  --search-text: #b2b2b2;
  --search-selected-value-text: var(--text-emphasis);
  --search-placeholder-color: #b2b2b2;
  --search-hover-text: var(--dropdown-hover-text);
  --search-chip-bg: var(--prime-btn-bkgd);
  --search-chip-text: var(--prime-btn-text);
  --search-chip-icon-filter: var(--button-icon-primary);
  --search-chip-icon-hover-filter: var(--search-chip-icon-filter);
  .searchContainer .searchRow,
  .searchContainer .searchLeftBox,
  .searchContainer .searchRightBox,
  .searchContainer .search-filters,
  .searchContainer .auto-filter-detail,
  .searchContainer .popover,
  .searchContainer .filterbtn,
  .searchContainer .fullWidthFilterPanel,
  .fullWidthFilterPanel {
    background: var(--search-surface) !important;
    color: var(--search-text) !important;
  }
  .searchContainer,
  .searchContainer .inputWrapper {
    background: none !important;
    color: var(--search-text) !important;
  }
  .searchContainer,
  .searchContainer .inputWrapper,
  .searchContainer .searchRow,
  .searchContainer .auto-filter-detail,
  .searchContainer .chipInside,
  .searchContainer [data-pc-name='multiselect'],
  .fullWidthFilterPanel,
  .fullWidthFilterPanel [data-pc-name='multiselect'],
  .searchContainer [data-pc-name='calendar'] input,
  .suggestionList,
  [data-pc-section='panel'],
  [id='search-filter-popover'][data-pc-section='root'] [data-pc-section='content'],
  [data-pc-name='overlaypanel'][data-pc-section='root'] {
    border-color: var(--border-elevated) !important;
  }
  .searchContainer input::placeholder,
  .searchContainer textarea::placeholder,
  .searchContainer .inlineText,
  .searchContainer .inlineText,
  .searchContainer .filterLabel,
  .searchContainer .smallBadge,
  .searchContainer .chipInside,
  .searchContainer .search-filter-chip,
  .fullWidthFilterPanel,
  .fullWidthFilterPanel .inlineText,
  .fullWidthFilterPanel .filterItem label,
  .fullWidthFilterPanel [data-pc-section='label'],
  .fullWidthFilterPanel [data-pc-section='labelcontainer'] div,
  .searchContainer [data-pc-section='label'],
  .searchContainer [data-pc-section='item'] span,
  .suggestionItem,
  .fullWidthFilterPanel .filterItem label,
  [id='search-filter-popover'] .filterLabel,
  [id='search-filter-popover'] .statusFilter span,
  [id='search-filter-popover'] [data-pc-section='list'] span {
    color: var(--search-text) !important;
  }
  .searchContainer input::placeholder,
  .searchContainer textarea::placeholder,
  .searchContainer .p-placeholder,
  .searchContainer [data-pc-section='label'][class~='p-placeholder'],
  .searchContainer [data-pc-section='label'].p-placeholder,
  .fullWidthFilterPanel .p-placeholder,
  .fullWidthFilterPanel [data-pc-section='label'][class~='p-placeholder'],
  .fullWidthFilterPanel [data-pc-section='label'].p-placeholder,
  [id='search-filter-popover'] .p-placeholder,
  [id='search-filter-popover'] [data-pc-section='label'][class~='p-placeholder'],
  [id='search-filter-popover'] [data-pc-section='label'].p-placeholder,
  [id='search-filter-popover'] .filtercont input::placeholder,
  [id='search-filter-popover'] .filtercont [data-pc-name='calendar'] input::placeholder {
    color: var(--search-placeholder-color) !important;
    opacity: 1;
  }
  .searchContainer input,
  .searchContainer textarea,
  .searchContainer .p-inputtext,
  .searchContainer .p-autocomplete-input,
  .searchContainer .p-autocomplete-input-chip input,
  [id='search-filter-popover'] .filtercont input,
  [id='search-filter-popover'] .filtercont [data-pc-name='calendar'] input {
    color: var(--text-emphasis) !important;
  }
  .searchContainer .chipInside,
  .searchContainer .chipInside .chipInputtext,
  .searchContainer .chipInside span,
  .searchContainer .search-filter-chip:not(.overflow),
  .suggestionList,
  .suggestionList li,
  .suggestionItem,
  .suggestionItem span,
  .suggestionItem div,
  [data-pc-name='autocomplete'] [data-pc-section='item'],
  [data-pc-name='autocomplete'] [data-pc-section='item'] span,
  [data-pc-name='autocomplete'] [data-pc-section='item'] div,
  .searchContainer [data-pc-name='multiselect'] [data-pc-section='label']:not(.p-placeholder),
  .searchContainer
    [data-pc-name='multiselect']
    [data-pc-section='labelcontainer']
    div:not(.p-placeholder),
  .fullWidthFilterPanel [data-pc-name='multiselect'] [data-pc-section='label']:not(.p-placeholder),
  .fullWidthFilterPanel
    [data-pc-name='multiselect']
    [data-pc-section='labelcontainer']
    div:not(.p-placeholder),
  [id='search-filter-popover']
    .filtercont
    [data-pc-name='multiselect']
    [data-pc-section='label']:not(.p-placeholder),
  [id='search-filter-popover']
    .filtercont
    [data-pc-name='multiselect']
    [data-pc-section='labelcontainer']
    div:not(.p-placeholder) {
    color: var(--search-selected-value-text) !important;
  }
  .inlineText,
  .searchContainer .inlineText,
  .fullWidthFilterPanel .inlineText,
  [id='search-filter-popover'] .inlineText {
    color: var(--search-text) !important;
  }
  .searchContainer input,
  .searchContainer textarea,
  .searchContainer .inputField {
    caret-color: var(--text-emphasis) !important;
  }
  .searchContainer input:focus,
  .searchContainer .inputField:focus,
  .searchContainer [data-pc-name='calendar'] input:focus {
    color: var(--text-emphasis) !important;
  }
  .searchContainer .moreCount,
  .searchContainer .search-filter-chip.overflow {
    background: var(--prime-btn-bkgd) !important;
    color: var(--text-emphasis) !important;
  }
  .fullWidthFilterPanel [class~='w-full'][data-pc-name='multiselect'],
  .fullWidthFilterPanel [data-pc-name='multiselect'],
  .fullWidthFilterPanel [class~='w-full'][class~='p-multiselect'] {
    background: var(--search-surface) !important;
    border-color: var(--border-elevated) !important;
    color: var(--search-text) !important;
  }
  .fullWidthFilterPanel {
    background: var(--search-surface) !important;
    border-color: var(--border-elevated) !important;
  }
  .fullWidthFilterPanel [data-pc-section='trigger'] img {
    filter: var(--search-icon-filter) !important;
    opacity: 1 !important;
  }
  .fullWidthFilterPanel [data-pc-section='trigger'] svg,
  .fullWidthFilterPanel [data-pc-section='trigger'] svg path {
    color: var(--search-icon-color) !important;
    fill: currentColor !important;
    stroke: currentColor !important;
    filter: var(--search-icon-filter) !important;
    opacity: 1 !important;
  }
  .fullWidthFilterPanel [class~='w-full'][data-pc-name='multiselect'] [data-pc-section='label'],
  .fullWidthFilterPanel
    [class~='w-full'][data-pc-name='multiselect']
    [data-pc-section='labelcontainer']
    div,
  .fullWidthFilterPanel [data-pc-name='multiselect'] [data-pc-section='label'],
  .fullWidthFilterPanel [data-pc-name='multiselect'] [data-pc-section='labelcontainer'] div {
    color: var(--search-text) !important;
  }
  [id='search-filter-popover'] .filtercont [data-pc-name='multiselect'],
  [id='search-filter-popover'] .filtercont [data-pc-name='calendar'] input {
    background: var(--search-surface) !important;
    border-color: var(--border-elevated) !important;
    color: var(--text-emphasis) !important;
  }
  [id='search-filter-popover'][data-pc-section='root'] {
    [data-pc-section='content'] {
      [class*='filtercont'] {
        [data-pc-name='multiselect'] {
          background: var(--search-surface) !important;
          border-color: var(--border-elevated) !important;
          color: var(--search-text) !important;
          [data-pc-section='labelcontainer'],
          [data-pc-section='trigger'],
          [data-pc-section='label'] {
            background: var(--search-surface) !important;
            color: var(--search-text) !important;
          }
          [data-pc-section='trigger'] svg,
          [data-pc-section='trigger'] svg path,
          [data-pc-section='trigger'] img {
            color: var(--search-icon-color) !important;
            fill: currentColor !important;
            stroke: currentColor !important;
            filter: var(--search-icon-filter) !important;
            opacity: 1 !important;
          }
        }
      }
    }
  }
  [id='search-filter-popover']
    .filtercont
    [data-pc-name='multiselect']
    [data-pc-section='labelcontainer'],
  [id='search-filter-popover'] .filtercont [data-pc-name='multiselect'] [data-pc-section='trigger'],
  [id='search-filter-popover'] .filtercont [data-pc-name='multiselect'] [data-pc-section='label'] {
    background: var(--search-surface) !important;
    color: var(--search-text) !important;
  }
  [id='search-filter-popover']
    .filtercont
    [data-pc-name='multiselect']
    [data-pc-section='trigger']
    svg,
  [id='search-filter-popover']
    .filtercont
    [data-pc-name='multiselect']
    [data-pc-section='trigger']
    svg
    path,
  [id='search-filter-popover']
    .filtercont
    [data-pc-name='multiselect']
    [data-pc-section='trigger']
    img {
    color: var(--search-icon-color) !important;
    fill: currentColor !important;
    stroke: currentColor !important;
    opacity: 1 !important;
    filter: var(--search-icon-filter) !important;
  }
  [id='search-filter-popover'] .filtercont [data-pc-name='multiselect'] [data-pc-section='label'],
  [id='search-filter-popover']
    .filtercont
    [data-pc-name='multiselect']
    [data-pc-section='labelcontainer']
    div,
  [id='search-filter-popover'] .filtercont [data-pc-name='calendar'] input::placeholder {
    color: var(--search-text) !important;
  }
  [id='search-filter-popover'] .filtercont [data-pc-name='calendar'] input::placeholder {
    color: var(--search-placeholder-color) !important;
  }
  .searchContainer .searchRow,
  .searchContainer.fullwidthContainer .searchRow {
    border-bottom-color: var(--border-elevated) !important;
  }
  .searchContainer img,
  .searchContainer .icon,
  [data-pc-section='trigger'] img,
  [data-pc-section='closebutton'] img {
    filter: var(--search-icon-filter) !important;
  }
  [id='search-filter-popover'] .filterfooter img,
  [id='search-filter-popover'] .filterfooter .icon,
  [data-pc-name='overlaypanel'] .filterfooter img,
  [data-pc-name='overlaypanel'] .filterfooter .icon {
    filter: var(--search-icon-filter) !important;
  }
  .searchContainer.autoContainer .inlineWrapper [data-pc-section='trigger'] img,
  .searchContainer.autoContainer .inlineWrapper [data-pc-section='trigger'] .icon,
  .searchContainer.autoContainer .inlineWrapper [data-pc-section='trigger'] [class*='icon'] img,
  .searchContainer.fullwidthContainer .inlineWrapper [data-pc-section='trigger'] img,
  .searchContainer.fullwidthContainer .inlineWrapper [data-pc-section='trigger'] .icon,
  .searchContainer.fullwidthContainer
    .inlineWrapper
    [data-pc-section='trigger']
    [class*='icon']
    img,
  .fullWidthFilterPanel .inlineWrapper [data-pc-section='trigger'] img,
  .fullWidthFilterPanel .inlineWrapper [data-pc-section='trigger'] .icon,
  .fullWidthFilterPanel .inlineWrapper [data-pc-section='trigger'] [class*='icon'] img {
    filter: var(--search-icon-filter) !important;
  }
  .searchContainer.autoContainer .inlineWrapper [data-pc-section='trigger'] svg,
  .searchContainer.autoContainer .inlineWrapper [data-pc-section='trigger'] svg path,
  .searchContainer.fullwidthContainer .inlineWrapper [data-pc-section='trigger'] svg,
  .searchContainer.fullwidthContainer .inlineWrapper [data-pc-section='trigger'] svg path,
  .fullWidthFilterPanel .inlineWrapper [data-pc-section='trigger'] svg,
  .fullWidthFilterPanel .inlineWrapper [data-pc-section='trigger'] svg path {
    color: var(--search-icon-color) !important;
    fill: currentColor !important;
    stroke: currentColor !important;
    filter: var(--search-icon-filter) !important;
  }
  .searchContainer .filterbtn:hover img,
  .searchContainer .filterbtn:hover .icon,
  .searchContainer .filterbtn:hover svg,
  .searchContainer .filterbtn:hover svg path,
  .searchContainer .searchButtonWrapper button:hover img,
  .searchContainer .searchButtonWrapper button:hover .icon,
  .searchContainer .searchButtonWrapper button:hover svg,
  .searchContainer .searchButtonWrapper button:hover svg path,
  .searchContainer [data-pc-name='multiselect'][aria-expanded='true'] img,
  .searchContainer [data-pc-name='multiselect'][aria-expanded='true'] svg,
  .searchContainer [data-pc-name='multiselect'][aria-expanded='true'] svg path,
  [data-pc-section='trigger']:hover img,
  [data-pc-section='trigger']:hover svg,
  [data-pc-section='trigger']:hover svg path,
  [data-pc-section='closebutton']:hover img,
  [data-pc-section='closebutton']:hover svg,
  [data-pc-section='closebutton']:hover svg path {
    color: var(--search-icon-hover-color) !important;
    fill: currentColor !important;
    stroke: currentColor !important;
    filter: var(--search-icon-hover-filter) !important;
  }
  .searchContainer.autoContainer .inlineWrapper:hover [data-pc-section='trigger'] img,
  .searchContainer.autoContainer .inlineWrapper:hover [data-pc-section='trigger'] .icon,
  .searchContainer.autoContainer
    .inlineWrapper:hover
    [data-pc-section='trigger']
    [class*='icon']
    img,
  .searchContainer.autoContainer
    .inlineWrapper:has([data-pc-name='multiselect'][aria-expanded='true'])
    [data-pc-section='trigger']
    img,
  .searchContainer.autoContainer
    .inlineWrapper:has([data-pc-name='multiselect'][aria-expanded='true'])
    [data-pc-section='trigger']
    .icon,
  .searchContainer.autoContainer
    [data-pc-name='multiselect'][aria-expanded='true']
    [data-pc-section='trigger']
    img,
  .searchContainer.autoContainer
    [data-pc-name='multiselect'][aria-expanded='true']
    [data-pc-section='trigger']
    .icon,
  .searchContainer.fullwidthContainer .inlineWrapper:hover [data-pc-section='trigger'] img,
  .searchContainer.fullwidthContainer .inlineWrapper:hover [data-pc-section='trigger'] .icon,
  .searchContainer.fullwidthContainer
    .inlineWrapper:hover
    [data-pc-section='trigger']
    [class*='icon']
    img,
  .searchContainer.fullwidthContainer
    .inlineWrapper:has([data-pc-name='multiselect'][aria-expanded='true'])
    [data-pc-section='trigger']
    img,
  .searchContainer.fullwidthContainer
    .inlineWrapper:has([data-pc-name='multiselect'][aria-expanded='true'])
    [data-pc-section='trigger']
    .icon,
  .searchContainer.fullwidthContainer
    [data-pc-name='multiselect'][aria-expanded='true']
    [data-pc-section='trigger']
    img,
  .searchContainer.fullwidthContainer
    [data-pc-name='multiselect'][aria-expanded='true']
    [data-pc-section='trigger']
    .icon,
  .fullWidthFilterPanel .inlineWrapper:hover [data-pc-section='trigger'] img,
  .fullWidthFilterPanel .inlineWrapper:hover [data-pc-section='trigger'] .icon,
  .fullWidthFilterPanel .inlineWrapper:hover [data-pc-section='trigger'] [class*='icon'] img,
  .fullWidthFilterPanel
    .inlineWrapper:has([data-pc-name='multiselect'][aria-expanded='true'])
    [data-pc-section='trigger']
    img,
  .fullWidthFilterPanel
    .inlineWrapper:has([data-pc-name='multiselect'][aria-expanded='true'])
    [data-pc-section='trigger']
    .icon,
  .fullWidthFilterPanel
    [data-pc-name='multiselect'][aria-expanded='true']
    [data-pc-section='trigger']
    img,
  .fullWidthFilterPanel
    [data-pc-name='multiselect'][aria-expanded='true']
    [data-pc-section='trigger']
    .icon {
    color: var(--search-icon-hover-color) !important;
    filter: var(--search-icon-hover-filter) !important;
  }
  .searchContainer.autoContainer .inlineWrapper:hover [data-pc-section='trigger'] svg,
  .searchContainer.autoContainer .inlineWrapper:hover [data-pc-section='trigger'] svg path,
  .searchContainer.autoContainer
    [data-pc-name='multiselect'][aria-expanded='true']
    [data-pc-section='trigger']
    svg,
  .searchContainer.autoContainer
    [data-pc-name='multiselect'][aria-expanded='true']
    [data-pc-section='trigger']
    svg
    path,
  .searchContainer.fullwidthContainer .inlineWrapper:hover [data-pc-section='trigger'] svg,
  .searchContainer.fullwidthContainer .inlineWrapper:hover [data-pc-section='trigger'] svg path,
  .searchContainer.fullwidthContainer
    [data-pc-name='multiselect'][aria-expanded='true']
    [data-pc-section='trigger']
    svg,
  .searchContainer.fullwidthContainer
    [data-pc-name='multiselect'][aria-expanded='true']
    [data-pc-section='trigger']
    svg
    path,
  .fullWidthFilterPanel .inlineWrapper:hover [data-pc-section='trigger'] svg,
  .fullWidthFilterPanel .inlineWrapper:hover [data-pc-section='trigger'] svg path,
  .fullWidthFilterPanel
    [data-pc-name='multiselect'][aria-expanded='true']
    [data-pc-section='trigger']
    svg,
  .fullWidthFilterPanel
    [data-pc-name='multiselect'][aria-expanded='true']
    [data-pc-section='trigger']
    svg
    path {
    color: var(--search-icon-hover-color) !important;
    fill: currentColor !important;
    stroke: currentColor !important;
    filter: var(--search-icon-hover-filter) !important;
  }
  .searchContainer .inlineWrapper:hover .inlineText,
  .searchContainer .inlineWrapper:hover [data-pc-section='label'],
  .searchContainer [data-pc-name='multiselect']:hover [data-pc-section='label'],
  .fullWidthFilterPanel .inlineWrapper:hover .inlineText,
  .fullWidthFilterPanel .inlineWrapper:hover [data-pc-section='label'],
  .fullWidthFilterPanel [data-pc-name='multiselect']:hover [data-pc-section='label'] {
    color: var(--search-hover-text) !important;
  }
  .suggestionList,
  .suggestionList li,
  [id='search-filter-popover'][data-pc-section='root'] [data-pc-section='content'],
  [id='search-filter-popover'] .filtercont,
  [id='search-filter-popover'] .filterfooter,
  [data-pc-section='panel'],
  [data-pc-name='overlaypanel'][data-pc-section='root'] {
    background: var(--search-surface) !important;
    color: var(--search-text) !important;
  }
  .suggestionList,
  .fullWidthFilterPanel,
  [data-pc-section='panel'],
  [id='search-filter-popover'][data-pc-section='root'] [data-pc-section='content'],
  [data-pc-name='overlaypanel'][data-pc-section='root'] {
    border: 1px solid var(--download-card-border, var(--border-elevated)) !important;
    border-radius: 8px !important;
  }
  [id='search-filter-popover'] .filtercont,
  [id='search-filter-popover'] .filtercont label,
  [id='search-filter-popover'] .filtercont span,
  [id='search-filter-popover'] .filtercont div,
  [id='search-filter-popover'] .filtercont input,
  [id='search-filter-popover'] .filtercont input::placeholder,
  [id='search-filter-popover'] .filtercont [data-pc-section='label'],
  [id='search-filter-popover'] .filtercont [data-pc-section='labelcontainer'] div {
    color: var(--search-text) !important;
  }
  [data-pc-section='panel'] [data-pc-section='item'] span,
  [data-pc-section='panel'] [data-pc-section='option'],
  [data-pc-section='panel'] [data-pc-section='label'] {
    color: var(--search-text) !important;
  }
  [id='search-filter-popover'] .filterheader,
  [data-pc-name='overlaypanel'] .filterheader {
    background: var(--surface-elevated) !important;
    color: var(--text-emphasis) !important;
    border-bottom-color: var(--border-elevated) !important;
  }
  [id='search-filter-popover'] .filterfooter,
  [data-pc-name='overlaypanel'] .filterfooter {
    border-top-color: var(--border-elevated) !important;
  }
  .suggestionItem:hover,
  body [data-pc-section='item']:hover,
  [data-pc-section='panel'] [data-pc-section='item']:hover,
  [data-pc-section='item']:hover,
  [data-pc-section='item'][data-p-highlight='true'],
  [data-pc-section='item'][aria-selected='true'],
  [data-pc-section='option']:hover,
  [data-pc-section='option'][aria-selected='true'],
  [data-p-focused='true'] {
    background: transparent !important;
    color: var(--search-hover-text) !important;
  }
  [data-pc-section='panel']:has(.filterItem) [data-pc-section='item'][data-p-highlight='true'],
  [data-pc-section='panel']:has(.filterItem) [data-pc-section='item'][aria-selected='true'],
  [data-pc-section='panel']:has(.filterItem) [data-pc-section='item'].p-highlight,
  [data-pc-section='panel']:has(.filterItem) [data-pc-section='option'][data-p-highlight='true'],
  [data-pc-section='panel']:has(.filterItem) [data-pc-section='option'][aria-selected='true'],
  [data-pc-section='panel']:has(.filterItem) [data-pc-section='option'].p-highlight,
  [data-pc-section='panel']:has(.filterItem) [data-p-focused='true'],
  [data-pc-section='panel']:has(.customCheckboxOption) [data-pc-section='item'][data-p-highlight='true'],
  [data-pc-section='panel']:has(.customCheckboxOption) [data-pc-section='item'][aria-selected='true'],
  [data-pc-section='panel']:has(.customCheckboxOption) [data-pc-section='item'].p-highlight,
  [data-pc-section='panel']:has(.customCheckboxOption) [data-pc-section='option'][data-p-highlight='true'],
  [data-pc-section='panel']:has(.customCheckboxOption) [data-pc-section='option'][aria-selected='true'],
  [data-pc-section='panel']:has(.customCheckboxOption) [data-pc-section='option'].p-highlight,
  [data-pc-section='panel']:has(.customCheckboxOption) [data-p-focused='true'] {
    background: transparent !important;
  }
  [data-pc-section='item'][data-p-highlight='true'] span,
  [data-pc-section='panel'] [data-pc-section='item'] span,
  [data-pc-section='item'][aria-selected='true'] span,
  [data-pc-section='option'][aria-selected='true'] span,
  [data-pc-section='option'][aria-selected='true'] {
    color: var(--search-hover-text) !important;
  }
  [data-pc-section='item'][data-p-highlight='true'] [icon],
  [data-pc-section='item'][aria-selected='true'] [icon] {
    background: var(--prime-btn-bkgd) !important;
    border-color: var(--prime-btn-bkgd) !important;
  }
  .searchContainer [data-pc-name='multiselect'],
  .searchContainer [data-pc-name='multiselect'].p-multiselect,
  .fullWidthFilterPanel [data-pc-name='multiselect'],
  .fullWidthFilterPanel [data-pc-name='multiselect'].p-multiselect,
  [id='search-filter-popover'] [data-pc-name='multiselect'],
  [id='search-filter-popover'] [data-pc-name='multiselect'][class~='p-multiselect'] {
    background: var(--search-surface) !important;
    color: var(--search-text) !important;
  }
  .searchContainer [data-pc-name='multiselect'] [data-pc-section='labelcontainer'],
  .searchContainer [data-pc-name='multiselect'] [data-pc-section='trigger'],
  .fullWidthFilterPanel [data-pc-name='multiselect'] [data-pc-section='labelcontainer'],
  .fullWidthFilterPanel [data-pc-name='multiselect'] [data-pc-section='trigger'],
  [id='search-filter-popover'] [data-pc-name='multiselect'] [data-pc-section='labelcontainer'],
  [id='search-filter-popover'] [data-pc-name='multiselect'] [data-pc-section='trigger'] {
    background: var(--search-surface) !important;
    color: var(--search-text) !important;
  }
  .searchContainer [data-button-type='tertiary'],
  .searchContainer .filterbtn [data-button-type='tertiary'] {
    background: var(--surface-elevated) !important;
    border-color: var(--border-elevated) !important;
    color: var(--text-emphasis) !important;
  }
  .searchContainer .closeIcon [data-button-type='tertiary'],
  .searchContainer .closeIcon [data-button-type='tertiary']:hover {
    background: transparent !important;
    border-color: transparent !important;
    box-shadow: none !important;
  }
  .searchContainer .closeIcon [data-button-type='tertiary']:hover img {
    filter: var(--search-icon-hover-filter) !important;
  }
  .searchContainer .closeIcon [data-button-type='tertiary']:hover svg,
  .searchContainer .closeIcon [data-button-type='tertiary']:hover svg path,
  .searchContainer .closeIcon [data-button-type='tertiary']:hover .icon {
    color: var(--search-icon-hover-color) !important;
    fill: currentColor !important;
    stroke: currentColor !important;
    filter: var(--search-icon-hover-filter) !important;
  }
  .searchContainer .searchLeftBox:hover .iconWrapper img,
  .searchContainer .searchLeftBox:hover .iconWrapper .icon,
  .searchContainer .searchLeftBox:hover .iconWrapper svg,
  .searchContainer .searchLeftBox:hover .iconWrapper svg path,
  .searchContainer .searchLeftBox:focus-within .iconWrapper img,
  .searchContainer .searchLeftBox:focus-within .iconWrapper .icon,
  .searchContainer .searchLeftBox:focus-within .iconWrapper svg,
  .searchContainer .searchLeftBox:focus-within .iconWrapper svg path,
  .searchContainer .filterbtn:hover [data-button-type='tertiary'] img,
  .searchContainer .filterbtn:hover [data-button-type='tertiary'] .icon,
  .searchContainer .filterbtn:hover [data-button-type='tertiary'] svg,
  .searchContainer .filterbtn:hover [data-button-type='tertiary'] svg path,
  .searchContainer .filtercloseButtonInside [data-button-type='tertiary']:hover img,
  .searchContainer .filtercloseButtonInside [data-button-type='tertiary']:hover .icon,
  .searchContainer .filtercloseButtonInside [data-button-type='tertiary']:hover svg,
  .searchContainer .filtercloseButtonInside [data-button-type='tertiary']:hover svg path {
    color: var(--search-icon-hover-color) !important;
    fill: currentColor !important;
    stroke: currentColor !important;
    filter: var(--search-icon-hover-filter) !important;
  }
  .searchContainer .inputActivePopover .filterbtn [data-button-type='tertiary'],
  .searchContainer [data-button-type='tertiary']:hover {
    background: transparent !important;
    border-color: transparent !important;
  }
  .searchContainer .searchButtonWrapper [data-button-type='tertiary'],
  .searchContainer .filterbtn [data-button-type='tertiary'],
  .searchContainer .filtercloseButtonInside [data-button-type='tertiary'] {
    background: transparent !important;
    border-color: transparent !important;
    box-shadow: none !important;
    img,
    .icon,
    svg,
    svg path {
      color: var(--search-icon-color) !important;
      fill: currentColor !important;
      stroke: currentColor !important;
      filter: var(--search-icon-filter) !important;
    }
  }
  .searchContainer .searchButtonWrapper [data-button-type='tertiary']:hover,
  .searchContainer .filterbtn:hover [data-button-type='tertiary'],
  .searchContainer .filterbtn [data-button-type='tertiary']:hover,
  .searchContainer .filtercloseButtonInside [data-button-type='tertiary']:hover {
    background: transparent !important;
    border-color: transparent !important;
    box-shadow: none !important;
    img,
    .icon,
    svg,
    svg path {
      color: var(--search-icon-hover-color) !important;
      fill: currentColor !important;
      stroke: currentColor !important;
      filter: var(--search-icon-hover-filter) !important;
    }
  }
  .searchContainer .searchLeftBox:hover .iconWrapper img,
  .searchContainer .searchLeftBox:hover .iconWrapper .icon,
  .searchContainer .searchLeftBox:hover .iconWrapper svg,
  .searchContainer .searchLeftBox:hover .iconWrapper svg path,
  .searchContainer .searchLeftBox:focus-within .iconWrapper img,
  .searchContainer .searchLeftBox:focus-within .iconWrapper .icon,
  .searchContainer .searchLeftBox:focus-within .iconWrapper svg,
  .searchContainer .searchLeftBox:focus-within .iconWrapper svg path {
    color: var(--search-icon-color) !important;
    fill: currentColor !important;
    stroke: currentColor !important;
    filter: var(--search-icon-filter) !important;
  }
  .searchContainer.fullwidthContainer .searchLeftBox:hover .iconWrapper img,
  .searchContainer.fullwidthContainer .searchLeftBox:hover .iconWrapper .icon,
  .searchContainer.fullwidthContainer .searchLeftBox:hover .iconWrapper svg,
  .searchContainer.fullwidthContainer .searchLeftBox:hover .iconWrapper svg path,
  .searchContainer.fullwidthContainer .searchLeftBox:focus-within .iconWrapper img,
  .searchContainer.fullwidthContainer .searchLeftBox:focus-within .iconWrapper .icon,
  .searchContainer.fullwidthContainer .searchLeftBox:focus-within .iconWrapper svg,
  .searchContainer.fullwidthContainer .searchLeftBox:focus-within .iconWrapper svg path,
  .searchContainer.fullwidthContainer .inlineWrapper:hover [data-pc-section='trigger'] img,
  .searchContainer.fullwidthContainer .inlineWrapper:hover [data-pc-section='trigger'] .icon,
  .searchContainer.fullwidthContainer .inlineWrapper:hover [data-pc-section='trigger'] svg,
  .searchContainer.fullwidthContainer .inlineWrapper:hover [data-pc-section='trigger'] svg path,
  .searchContainer.fullwidthContainer
    .inlineWrapper:has([data-pc-name='multiselect'][aria-expanded='true'])
    [data-pc-section='trigger']
    img,
  .searchContainer.fullwidthContainer
    .inlineWrapper:has([data-pc-name='multiselect'][aria-expanded='true'])
    [data-pc-section='trigger']
    .icon,
  .searchContainer.fullwidthContainer
    .inlineWrapper:has([data-pc-name='multiselect'][aria-expanded='true'])
    [data-pc-section='trigger']
    svg,
  .searchContainer.fullwidthContainer
    .inlineWrapper:has([data-pc-name='multiselect'][aria-expanded='true'])
    [data-pc-section='trigger']
    svg
    path {
    color: var(--search-icon-color) !important;
    fill: currentColor !important;
    stroke: currentColor !important;
    filter: var(--search-icon-filter) !important;
  }
  .searchContainer.fullwidthContainer
    .inlineWrapper:hover
    [data-pc-name='multiselect']
    [data-pc-section='trigger'],
  .searchContainer.fullwidthContainer
    .inlineWrapper:has([data-pc-name='multiselect'][aria-expanded='true'])
    [data-pc-name='multiselect']
    [data-pc-section='trigger'],
  .searchContainer.fullwidthContainer
    [data-pc-name='multiselect']:hover
    [data-pc-section='trigger'],
  .searchContainer.fullwidthContainer
    [data-pc-name='multiselect'][aria-expanded='true']
    [data-pc-section='trigger'] {
    color: var(--search-icon-color) !important;
    .icon-container,
    [class*='icon-container'] {
      filter: none !important;
      opacity: 1 !important;
    }
    img,
    .icon,
    [class*='icon'] img,
    .icon-container img,
    svg,
    svg path {
      color: var(--search-icon-color) !important;
      fill: currentColor !important;
      stroke: currentColor !important;
      filter: var(--search-icon-filter) !important;
      opacity: 1 !important;
    }
  }
  .searchContainer .chipInside {
    background: var(--search-chip-bg) !important;
    border-color: var(--search-chip-bg) !important;
    color: var(--search-chip-text) !important;
  }
  .searchContainer .chipInside .chipInputtext,
  .searchContainer .chipInside span {
    color: var(--search-chip-text) !important;
  }
  .searchContainer .chipInside [data-button-type='tertiary'] {
    background: transparent !important;
    border-color: transparent !important;
    border-bottom: 0 !important;
    box-shadow: none !important;
    img,
    .icon,
    svg,
    svg path {
      color: var(--search-chip-text) !important;
      fill: currentColor !important;
      stroke: currentColor !important;
      filter: var(--search-chip-icon-filter) !important;
    }
  }
  .searchContainer .chipInside [data-button-type='tertiary']:hover {
    background: transparent !important;
    border-color: transparent !important;
    border-bottom: 0 !important;
    box-shadow: none !important;
    img,
    .icon,
    svg,
    svg path {
      color: var(--search-chip-text) !important;
      fill: currentColor !important;
      stroke: currentColor !important;
      filter: var(--search-chip-icon-hover-filter) !important;
    }
  }
  .searchContainer.fullwidthContainer .searchRightBox .inlineWrapper [data-pc-section='trigger'],
  .searchContainer.fullwidthContainer
    .searchRightBox
    .inlineWrapper
    [data-pc-section='trigger']:hover,
  .searchContainer.fullwidthContainer
    .searchRightBox
    .inlineWrapper:hover
    [data-pc-section='trigger'],
  .searchContainer.fullwidthContainer
    .searchRightBox
    .inlineWrapper
    [data-pc-name='multiselect'][aria-expanded='true']
    [data-pc-section='trigger'] {
    color: var(--search-icon-color) !important;
    filter: none !important;
    opacity: 1 !important;
    .icon-container,
    [class*='icon-container'],
    [class*='triggerIcon'],
    [class*='trigger-icon'],
    [class*='p-multiselect-trigger-icon'] {
      color: var(--search-icon-color) !important;
      filter: none !important;
      opacity: 1 !important;
    }
    img,
    .icon,
    [class*='triggerIcon'] img,
    [class*='trigger-icon'] img,
    [class*='p-multiselect-trigger-icon'] img,
    .icon-container img,
    svg,
    svg path {
      color: var(--search-icon-color) !important;
      fill: currentColor !important;
      stroke: currentColor !important;
      filter: var(--search-icon-filter) !important;
      opacity: 1 !important;
      visibility: visible !important;
    }
  }
  .searchContainer .inlineWrapper:hover [data-pc-section='trigger'],
  .searchContainer [data-pc-name='multiselect']:hover [data-pc-section='trigger'],
  .fullWidthFilterPanel .inlineWrapper:hover [data-pc-section='trigger'],
  .fullWidthFilterPanel [data-pc-name='multiselect']:hover [data-pc-section='trigger'] {
    color: var(--search-icon-hover-color) !important;
    img,
    .icon,
    [class*='icon'] img,
    svg,
    svg path {
      color: var(--search-icon-hover-color) !important;
      fill: currentColor !important;
      filter: var(--search-icon-hover-filter) !important;
      stroke: currentColor !important;
    }
  }
  .searchContainer,
  .searchContainer.fullwidthContainer,
  .searchContainer.autoContainer,
  .searchContainer .inputWrapper {
    background: none !important;
  }
  .searchContainer .closeIcon [data-button-type='tertiary'],
  .searchContainer .filtercloseButtonInside .closeIcon [data-button-type='tertiary'] {
    align-items: center !important;
    background: transparent !important;
    border-color: transparent !important;
    border-radius: 50% !important;
    box-shadow: none !important;
    display: inline-flex !important;
    height: 44px !important;
    justify-content: center !important;
    min-width: 44px !important;
    padding: 0 !important;
    width: 44px !important;
  }
  .searchContainer .closeIcon [data-button-type='tertiary']:hover,
  .searchContainer .filtercloseButtonInside .closeIcon [data-button-type='tertiary']:hover {
    background: transparent !important;
    border-color: transparent !important;
    border-radius: 50% !important;
  }
  .searchContainer .inlineWrapper:hover [data-pc-section='trigger'],
  .searchContainer .inlineWrapper:has([data-pc-name='multiselect'][aria-expanded='true'])
    [data-pc-section='trigger'],
  .searchContainer [data-pc-name='multiselect']:hover [data-pc-section='trigger'],
  .searchContainer [data-pc-name='multiselect'][aria-expanded='true'] [data-pc-section='trigger'],
  .fullWidthFilterPanel .inlineWrapper:hover [data-pc-section='trigger'],
  .fullWidthFilterPanel .inlineWrapper:has([data-pc-name='multiselect'][aria-expanded='true'])
    [data-pc-section='trigger'],
  .fullWidthFilterPanel [data-pc-name='multiselect']:hover [data-pc-section='trigger'],
  .fullWidthFilterPanel
    [data-pc-name='multiselect'][aria-expanded='true']
    [data-pc-section='trigger'] {
    opacity: 1 !important;
    visibility: visible !important;
    img,
    .icon,
    [class*='icon'] img,
    svg,
    svg path {
      color: var(--search-icon-hover-color) !important;
      fill: currentColor !important;
      filter: var(--search-icon-hover-filter) !important;
      opacity: 1 !important;
      stroke: currentColor !important;
      visibility: visible !important;
    }
  }
  .searchContainer [data-pc-section='trigger']:hover img[alt='Chevron Down'],
  .searchContainer [data-pc-section='trigger']:hover img[alt='Chevron Up'],
  .searchContainer [data-pc-name='multiselect'][aria-expanded='true']
    [data-pc-section='trigger']
    img[alt='Chevron Down'],
  .searchContainer [data-pc-name='multiselect'][aria-expanded='true']
    [data-pc-section='trigger']
    img[alt='Chevron Up'],
  .fullWidthFilterPanel [data-pc-section='trigger']:hover img[alt='Chevron Down'],
  .fullWidthFilterPanel [data-pc-section='trigger']:hover img[alt='Chevron Up'],
  .fullWidthFilterPanel [data-pc-name='multiselect'][aria-expanded='true']
    [data-pc-section='trigger']
    img[alt='Chevron Down'],
  .fullWidthFilterPanel [data-pc-name='multiselect'][aria-expanded='true']
    [data-pc-section='trigger']
    img[alt='Chevron Up'] {
    filter: var(--search-icon-hover-filter) !important;
    opacity: 1 !important;
    visibility: visible !important;
  }
  .searchContainer [data-pc-name='multiselect']:hover img[alt='Chevron Down'],
  .searchContainer [data-pc-name='multiselect']:hover img[alt='Chevron Up'],
  .searchContainer [data-pc-name='multiselect']:hover [class*='icon-container'] img,
  .searchContainer [data-pc-name='multiselect']:hover [class*='baseicon'],
  .searchContainer [data-pc-name='multiselect'][aria-expanded='true'] img[alt='Chevron Down'],
  .searchContainer [data-pc-name='multiselect'][aria-expanded='true'] img[alt='Chevron Up'],
  .searchContainer [data-pc-name='multiselect'][aria-expanded='true'] [class*='icon-container'] img,
  .searchContainer [data-pc-name='multiselect'][aria-expanded='true'] [class*='baseicon'],
  .fullWidthFilterPanel [data-pc-name='multiselect']:hover img[alt='Chevron Down'],
  .fullWidthFilterPanel [data-pc-name='multiselect']:hover img[alt='Chevron Up'],
  .fullWidthFilterPanel [data-pc-name='multiselect']:hover [class*='icon-container'] img,
  .fullWidthFilterPanel [data-pc-name='multiselect']:hover [class*='baseicon'],
  .fullWidthFilterPanel [data-pc-name='multiselect'][aria-expanded='true'] img[alt='Chevron Down'],
  .fullWidthFilterPanel [data-pc-name='multiselect'][aria-expanded='true'] img[alt='Chevron Up'],
  .fullWidthFilterPanel
    [data-pc-name='multiselect'][aria-expanded='true']
    [class*='icon-container']
    img,
  .fullWidthFilterPanel [data-pc-name='multiselect'][aria-expanded='true'] [class*='baseicon'] {
    color: var(--search-icon-hover-color) !important;
    filter: var(--search-icon-hover-filter) !important;
    opacity: 1 !important;
    visibility: visible !important;
  }
  .searchContainer .inlineText,
  .searchContainer .filterLabel,
  .searchContainer .filterItem label,
  .searchContainer .chipInside,
  .searchContainer .chipInside .chipInputtext,
  .searchContainer .chipInside span,
  .searchContainer .search-filter-chip:not(.overflow),
  .suggestionList,
  .suggestionList li,
  .suggestionItem,
  .suggestionItem span,
  .suggestionItem div,
  [data-pc-name='autocomplete'] [data-pc-section='item'],
  [data-pc-name='autocomplete'] [data-pc-section='item'] span,
  [data-pc-name='autocomplete'] [data-pc-section='item'] div,
  .searchContainer [data-pc-name='multiselect'] [data-pc-section='label']:not(.p-placeholder),
  .searchContainer
    [data-pc-name='multiselect']
    [data-pc-section='labelcontainer']
    div:not(.p-placeholder),
  .fullWidthFilterPanel .inlineText,
  .fullWidthFilterPanel .filterItem label,
  .searchFilterPopover .inlineText,
  .searchFilterPopover label[for='datePicker'],
  .searchFilterPopover label[for='datePicker'] span:first-child,
  .searchFilterPopover .statusFilter span,
  .searchFilterPopover .allstatus span,
  .fullWidthFilterPanel [data-pc-name='multiselect'] [data-pc-section='label']:not(.p-placeholder),
  .fullWidthFilterPanel
    [data-pc-name='multiselect']
    [data-pc-section='labelcontainer']
    div:not(.p-placeholder),
  [id='search-filter-popover'] .filterLabel,
  [id='search-filter-popover'] .filtercont label,
  [id='search-filter-popover']
    .filtercont
    [data-pc-name='multiselect']
    [data-pc-section='label']:not(.p-placeholder),
  [id='search-filter-popover']
    .filtercont
    [data-pc-name='multiselect']
    [data-pc-section='labelcontainer']
    div:not(.p-placeholder) {
    color: var(--search-selected-value-text) !important;
  }
  .searchContainer .chipInside,
  .searchContainer .chipInside .chipInputtext,
  .searchContainer .chipInside span {
    color: var(--search-chip-text) !important;
  }
  .searchFilterPopover .statusFilter img,
  .searchFilterPopover .allstatus img,
  .searchFilterPopover img[class*='status-svg-icon'],
  .searchFilterPopover [class*='status-icon'] img {
    filter: unset !important;
  }
  .searchContainer .moreCount,
  .searchContainer .search-filter-chip.overflow,
  .searchContainer .chipInside.chipPluse,
  .searchContainer .chipPluse {
    color: var(--search-chip-text) !important;
  }
  .suggestionList,
  .suggestionList li,
  .suggestionItem,
  [data-pc-name='autocomplete'] [data-pc-section='item'],
  [data-pc-section='panel'] [data-pc-section='item'],
  [data-pc-section='panel'] [data-pc-section='option'],
  [id='search-filter-popover'] [data-pc-section='item'],
  [id='search-filter-popover'] [data-pc-section='option'] {
    color: var(--text-emphasis) !important;
    span,
    div {
      color: var(--text-emphasis) !important;
    }
    &:hover,
    &.p-focus,
    &[aria-selected='true'],
    &[data-p-highlight='true'],
    &[data-p-focused='true'] {
      color: var(--text-emphasis) !important;
      span,
      div {
        color: var(--text-emphasis) !important;
      }
    }
  }
  [data-pc-section='panel'] [data-pc-section='label'],
  [data-pc-section='panel'] [data-pc-section='labelcontainer'] div,
  [id='search-filter-popover'] [data-pc-section='label'],
  [id='search-filter-popover'] [data-pc-section='labelcontainer'] div {
    color: var(--text-emphasis) !important;
  }
  .searchContainer input,
  .searchContainer textarea,
  .searchContainer .p-inputtext,
  .searchContainer .p-autocomplete-input,
  .searchContainer .p-autocomplete-input-chip input,
  .searchContainer .p-autocomplete-input-multiple input,
  [id='search-filter-popover'] .filtercont input,
  [id='search-filter-popover'] .filtercont [data-pc-name='calendar'] input,
  [id='search-filter-popover'][data-pc-section='root'] .p-inputtext {
    color: var(--text-emphasis) !important;
  }
  .searchContainer input::placeholder,
  .searchContainer textarea::placeholder,
  .searchContainer .p-inputtext::placeholder,
  .searchContainer .p-autocomplete-input::placeholder,
  .searchContainer .p-autocomplete-input-chip input::placeholder,
  .searchContainer .p-autocomplete-input-multiple input::placeholder,
  [id='search-filter-popover'] .filtercont input::placeholder,
  [id='search-filter-popover'] .filtercont [data-pc-name='calendar'] input::placeholder,
  [id='search-filter-popover'][data-pc-section='root'] .p-inputtext::placeholder {
    color: var(--text-subtle-strong) !important;
    opacity: 1;
  }
}
[id='search-filter-popover'][data-pc-section='root'] [data-pc-section='closebutton'] [alt='Close'] {
  width: 20px !important;
  height: 20px !important;
}
